module.exports = __webpack_public_path__ + "static/media/jaune.4de5bd35.png";